<template>
    <div>
        <page-title-bar></page-title-bar>
        <v-container fluid grid-list-xl py-0>
            <app-card customClasses="mb-30 elevation-5">

                <v-data-table :items="users" :headers="headers" item-key="id" v-if="users.length > 0" hide-actions>
                    <template v-slot:items="props">
                        <td>{{ props.item.signInName }}</td>
                        <td>{{ props.item.firstName }}</td>
                        <td>{{ props.item.lastName }}</td>
                        <td>{{ props.item.isAdmin ? 'Si' : '' }}</td>
                        <td class="column text-xs-right">
                            <router-link :to="'/users/' + props.item.id">Edit</router-link>&nbsp;&nbsp;
                            <a href="#" @click="onDeleteClick(props.item.id, $event)" v-if="!props.item.isAdmin">Elimina</a>
                        </td>
                    </template>
                </v-data-table>

            </app-card>
        </v-container>

        <v-dialog v-model="showDeleteDialog"
                  max-width="290">
            <v-card>
                <v-card-title class="headline">Conferma eliminazione</v-card-title>
                <v-card-text>
                    Si vuole procedere con l'eliminazione dell'utente?
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn color="green darken-1"
                           flat="flat"
                           @click="showDeleteDialog = false">
                        No
                    </v-btn>

                    <v-btn color="green darken-1"
                           flat="flat"
                           @click="onConfirmDelete">
                        Si
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import api from "Api";

    export default {
        data() {
            return {
                userIdToDelete: 0,
                showDeleteDialog: false,
                headers: [
                    {
                        text: 'Username',
                        align: 'left',
                        value: 'signInName',
                        sortable: false
                    },
                    {
                        text: 'Nome',
                        align: 'left',
                        value: 'firstName',
                        sortable: false
                    },
                    {
                        text: 'Cognome',
                        align: 'left',
                        value: 'lastName',
                        sortable: false
                    },
                    {
                        text: 'Admin',
                        align: 'left',
                        sortable: false
                    },
                    {
                        text: '',
                        align: 'right',
                        sortable: false
                    }
                ],
                users: []
            };
        },

        mounted() {
            const instance = this;

            instance.fetchUsers();
        },

        methods: {
            fetchUsers() {
                const instance = this;

                api.instance.get("users")
                    .then((res) => {
                        instance.users = res.data;
                    });
            },

            onDeleteClick(userId, e) {
                e.preventDefault();
                const instance = this;

                instance.userIdToDelete = userId;
                instance.showDeleteDialog = true;
            },

            onConfirmDelete() {
                const instance = this;

                api.instance.delete(`users/${instance.userIdToDelete}`)
                    .then((res) => {
                        instance.showDeleteDialog = false;
                        instance.fetchUsers();
                    });
            }
        }
    };

</script>